import React from 'react';
import { useLanguage } from '../context/LanguageContext';

function Hero() {
  const { t } = useLanguage();

  return (
    <section id="home">
      <div className="hero-mobile-image">
        <img src="/images/hero-banner-mobile.webp" alt="Jeet Kune Do Zurich" />
      </div>
      
      <div className="hero-desktop-container">
        <div className="hero-content">
          <h1>{t.hero.title}</h1>
          <p>{t.hero.subtitle}</p>
          <div className="hero-buttons">
            <a href="https://docs.google.com/forms/d/1UYNWIYzQmMpG-_qwSAGJJ91QxA8dB4VTOehR0GbS8wQ/viewform " className="btn" target="_blank" rel="noopener noreferrer">{t.hero.bookTrial}</a>
            <a href="#footer-classes" className="btn btn-secondary">{t.hero.viewSchedule}</a>
          </div>
        </div>
        <div className="hero-desktop-image">
          <img src="/images/hero-image-desktop.webp" alt="Mike" />
        </div>
      </div>
    </section>
  );
}

export default Hero;


